export class EmailConstants {
  public static emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  public static isValidEmailIfNotMandatory(email: string | undefined): boolean {
    return email == undefined || email?.length == 0 || (email?.length >= 0 && this.emailRegex.test(email));
  }
}
